<template>

    <div v-show="isTutoActive" ref="tutoContainer" class="tuto-container">

        <popup-tuto-welcome
            ref="popupTutoWelcome"
            @close="closeTutoWelcome"
        ></popup-tuto-welcome>

        <overlay-tuto-list
            ref="overlay"
            @close="closeOverlay"
        ></overlay-tuto-list>

    </div>

</template>

<script>

import OverlayTutoList from '@/components/tuto/OverlayTutoList'
import PopupTutoWelcome from '@/components/popup/PopupTutoWelcome'

export default {

    name: 'tuto-list',

    components: {OverlayTutoList, PopupTutoWelcome},

    props: {

        anchor: {}
    },

    data: () => {

        return {
            step: 0,
            showWelcome: true,
            showOverlay: false,
            showChoice: false,
            warningDelete: true,
            warningKeep: true,
            warningUnsubscribe: true,
            finish: false,
            completed: false,
            isTutoActive: false
        }
    },

    methods: {

        start() {

            this.isTutoActive = true
            this.$refs.popupTutoWelcome.open()
        },

        closeTutoWelcome() {

            const self = this

            if (this.$mq === 'lg') {

                this.closeTuto()

            } else {

                setTimeout(function () {
                    self.$refs.overlay.open()
                    self.step = self.step + 1
                }, 400)

            }

        },

        closeOverlay() {

            this.showOverlay = false
            this.step = this.step + 1
            // wait parent call method cardEventClick()
            this.$refs.tutoContainer.style.width = 0

            // old closeChoice()
            this.showChoice = false
            this.closeTuto()
        },

        closeTuto() {

            this.isTutoActive = false
            this.completed = true
            this.$emit('close')
        }

    }

}
</script>

<style lang="scss" scoped>

.tuto-container {
    position: fixed;
    z-index: 2;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
}

</style>
